(() => {
  function bindProductCardFallbacks() {
    document
      .querySelectorAll('.product-card__media-wrap .product-card__image, .product-card__media-wrap .product-card__variant-image')
      .forEach((img) => {
        if (img.dataset.fallbackBound === 'true') return;
        img.dataset.fallbackBound = 'true';

        img.addEventListener('error', () => {
          const wrapper = img.closest('.product-card__media-wrap');
          if (!wrapper) return;

          wrapper.classList.add('is-fallback-visible');
          img.style.display = 'none';

          const fallback = wrapper.querySelector('.product-card__fallback');
          if (fallback) {
            fallback.setAttribute('aria-hidden', 'false');
          }
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindProductCardFallbacks);
  } else {
    bindProductCardFallbacks();
  }
})();